import Vue from 'vue';
import store from '../store';
import API from '../../services/api';
import userRights from '../../services/user-rights';

import VueTables from 'vue-tables-2';
import PortalVue from 'portal-vue';
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification';

// Global components
import '../components/the-subheader';
import '../components/the-sidebar-layout';
import '../components/the-1-column-layout';

Vue.use(Notifications);
Vue.use(PortalVue);

Vue.use(VueTables.ClientTable, {
  sortIcon: {
    is: 'icon--chevron-up-down--black',
    base: 'icon',
    up: 'icon--chevron-up--black',
    down: 'icon--chevron-down--black'
  }
}, false, () => { return {
  framework: '',
  table: 'table v-data-table',
  row: 'v-data-table__row',
  column: 'v-data-table__col',
  label: '',
  input: 'v-data-table__input',
  select: 'v-data-table__select',
  field: 'v-data-table__field',
  inline: 'is-inline',
  right: 'is-pull-right',
  left: 'is-pull-left',
  center: 'text-center',
  contentCenter: '',
  small: '',
  nomargin: '',
  groupTr: 'v-data-table__info',
  button: 'btn btn-secondary',
  dropdown: {
    container: 'dropdown',
    trigger: 'dropdown-toggle',
    menu: 'dropdown-menu',
    content: '',
    item: '',
    caret: 'caret'
  },
  pagination: {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active'
  }
}});
Vue.use(VModal, {
  dialog: true
});

Vue.prototype.$api = new API();
Vue.prototype.$userRights = new userRights();


// Global localization function {{loc('user.firstName')}}
Vue.mixin({
  data: function() {
    return {
      loc(keys) {
        if(!store.state.localization) {
          return '';
        }

        const keysOriginal = keys;

        if(!Array.isArray(keys)) {
          keys = keys.split('.');
        }

        let value;

        keys.forEach((key) => {
          value = value ? value[key] : store.state.localization[key];
        });

        if(typeof value === 'undefined' || value === null) {
          return 'missing: "' + keysOriginal + '"';
        }

        return value;
      }
    }
  }
});
